'use client'

import Image from 'next/image'
import { Group, Stack, Text, UnstyledButton } from '@mantine/core'
import { IconArrowRight } from '@tabler/icons-react'
import { getTeaserIconSrc } from './pharmacyChainIcon'
import classes from './BrowsePharmaciesLink.module.css'

const CHAIN_NAMES = ['CVS', 'Walgreens', 'Walmart']

interface BrowsePharmaciesLinkProps {
    onClick: () => void
}

export function BrowsePharmaciesLink({ onClick }: BrowsePharmaciesLinkProps) {
    return (
        // max-width matches the button/cards above it (their own max-width: 407px) so
        // "align center" centers this under them, rather than under the wider column.
        <Stack gap={4} align="center" className={classes.wrapper}>
            <UnstyledButton onClick={onClick}>
                <Group gap={12} align="center" justify="center" wrap="nowrap">
                    <div className={classes.iconStack}>
                        {CHAIN_NAMES.map((name, index) => {
                            const src = getTeaserIconSrc(name)
                            return (
                                src && (
                                    <Image
                                        key={name}
                                        src={src}
                                        alt={name}
                                        width={36}
                                        height={36}
                                        className={classes.icon}
                                        style={{ zIndex: CHAIN_NAMES.length - index }}
                                    />
                                )
                            )
                        })}
                    </div>
                    <Group gap={4} wrap="nowrap">
                        <Text fz={14} fw="var(--gm-weight-label, 425)" c="var(--gm-foreground-fg-highlight)">
                            Browse pharmacies
                        </Text>
                        <IconArrowRight size={16} color="var(--gm-foreground-fg-highlight)" />
                    </Group>
                </Group>
            </UnstyledButton>
            <Text fz={12} fw="var(--gm-weight-text, 450)" c="var(--gm-foreground-fg-tertiary)">
                Compare prices at 50K+ pharmacies nationwide
            </Text>
        </Stack>
    )
}
